// Outline heart that fills in when `filled` is true. Uses currentColor so the
// parent controls the colour.
function HeartIcon({filled=false, size=20, className=''}){
    return(
        <svg
            className={`heart-icon ${filled ? 'filled' : ''} ${className}`}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={filled ? 'currentColor' : 'none'}
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            <path d="M12 20.5s-7.5-4.6-9.3-9.2C1.5 8.2 3.4 4.5 7 4.5c2.1 0 3.6 1.2 5 3 1.4-1.8 2.9-3 5-3 3.6 0 5.5 3.7 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/>
        </svg>
    )
}

export default HeartIcon
